import React from 'react';
import { Container } from 'react-bootstrap';

const PrivacyPage = () => (
  <Container className="py-5" style={{ maxWidth: 800 }}>
    <h1>Privacy Policy</h1>
    <p className="text-muted">Last updated: July 17, 2026</p>
    <p>
      mikewilliams.us is the personal website of Mike Williams. It is operated by a single
      individual for personal use.
    </p>
    <h5>What data is collected</h5>
    <p>
      Public pages of this site do not collect personal information. The site's private,
      login-protected admin area is used solely by the site owner and may store personal data the
      owner enters or connects himself, including health and fitness data synced from connected
      services (such as Oura) with the owner's explicit authorization.
    </p>
    <h5>How data is used</h5>
    <p>
      Connected-service data is used only to display the site owner's own information back to him
      in the private admin area. It is never sold, shared, published, or used for advertising, and
      is not accessible to other visitors.
    </p>
    <h5>Data storage and deletion</h5>
    <p>
      Data is stored in a private database controlled by the site owner. Because the only user is
      the owner, any stored data or connected-service authorization can be deleted by the owner at
      any time. Questions can be sent to mike@mikewilliams.us.
    </p>
  </Container>
);

export default PrivacyPage;
